import TextTab from "./tabs/TextTab";
import MediaTab from "./tabs/MediaTab";
import ShapesTab from "./tabs/ShapesTab";
import HumatarTab from "./tabs/HumatarTab";
import TemplateTab from "./tabs/TemplateTab";
import SoundtrackTab from "./tabs/SoundtrackTab";
import BackgroundTab from "./tabs/BackgroundTab";
import { ProfileHumanSidebarType } from "../../../types/human";
import { SentryErrors, sentryErrors } from "../../../lib/sentry";
import AIHumansEditor from "./AIHumansEditor";
import { IActor } from "../../../types/actor";

interface Props {
  activeSubSidebarData: any;
  setBackgroundRef: (b: boolean) => void;
  setActorActive: (actors: IActor[]) => void;
  setIsPlayScript: React.Dispatch<React.SetStateAction<boolean>>;
  backgroundSoundTrackId: number | null;
  handleBackgroundSoundTrackId: (id: number) => void;
}

const Sidebar = ({
  activeSubSidebarData,
  setBackgroundRef,
  setActorActive,
  setIsPlayScript,
  backgroundSoundTrackId,
  handleBackgroundSoundTrackId,
}: Props) => {
  switch (activeSubSidebarData.type) {
    case ProfileHumanSidebarType.Humatar:
      return <HumatarTab />;
    case ProfileHumanSidebarType.Script:
      return <AIHumansEditor setActorActive={setActorActive} setIsPlayScript={setIsPlayScript} />;
    case ProfileHumanSidebarType.Background:
      return <BackgroundTab setBackgroundRef={setBackgroundRef} />;
    case ProfileHumanSidebarType.Shapes:
      return <ShapesTab />;
    case ProfileHumanSidebarType.Soundtrack:
      return (
        <SoundtrackTab
          backgroundSoundTrackId={backgroundSoundTrackId}
          handleBackgroundSoundTrackId={handleBackgroundSoundTrackId}
        />
      );
    case ProfileHumanSidebarType.Text:
      return <TextTab />;
    case ProfileHumanSidebarType.Media:
      return <MediaTab />;
    case ProfileHumanSidebarType.Templates:
      return <TemplateTab />;
    default:
      sentryErrors({
        errorType: SentryErrors.NON_EXISTENT_TAB,
        details: {
          type: activeSubSidebarData.type,
        },
      });
      return <></>;
  }
};

export default Sidebar;
